// extracted by css-extract-rspack-plugin
export default {"details":"wVWD5BIy4no_W95p","header":"gbH1MPb4CYwP3Ld4","list":"n4rUS4Ohv0OQZPlC"};